// import fun
import Layout from '@/page/layout'

const _import = require('../_import')
// scope dash
const scope = 'houseManage'

export default {
  path: '/house',
  name: 'house',
  component: Layout,
  meta: { title: '房源管理', icon: '' },
  redirect: '/house/myHouse',
  children: [
    {
      path: 'myHouse',
      name: 'myHouse',
      component: _import(`${scope}/MyHouse/index`),
      meta: { title: '我的房源', icon: '' }
    },
    {
      path: 'trusteeship',
      name: 'trusteeship',
      component: _import(`house/Trusteeship/index`),
      meta: { title: '房东合同', icon: '' }
    },
    {
      path: 'fee',
      name: 'fee',
      component: _import(`house/Fee/index`),
      meta: { title: '空调数据', icon: '' }
    },
    {
      path: 'housePrice',
      name: 'housePrice',
      component: _import(`house/HousePriceConfig/index`),
      meta: { title: '房价配置', icon: '' }
    },
    {
      path: 'energy',
      name: 'energy',
      component: _import(`house/EnergyConfig/index`),
      meta: { title: '能耗费配置', icon: '' }
    },
    {
      path: 'equipment',
      name: 'equipment',
      component: _import(`house/EquipmentConfig/index`),
      meta: { title: '设备配置', icon: '' }
    },
    {
      path: 'market',
      name: 'market',
      component: _import(`house/MarketRule/index`),
      meta: { title: '营销规则', icon: '' }
    },
    {
      path: 'jx-export',
      name: 'jx-export',
      component: _import(`house/jxExport/index`),
      meta: { title: '建信导入', icon: '' }
    },
    {
      path: 'online-export',
      name: 'online-export',
      component: _import(`house/onLineExport/index`),
      meta: { title: '账单批量导入', icon: '' }
    },
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/houseManage.js